import React, { useState } from 'react';
import BaseTableNew from 'components/atoms/base-table/new';
import {
  useGetCombinedStatusLogs,
  COMBINED_STATUS_LOGS_PER_PAGE,
} from 'infrastructure/hooks/logs/use-combined-status-logs';

import { logsColumns } from './columns';

import type { DateRange } from 'infrastructure/types';

interface IRpmCcmStatusLogProps {
  patientGuid: string;
  dateRange?: DateRange;
}

const RpmCcmStatusLog: React.FC<IRpmCcmStatusLogProps> = (props) => {
  const [page, setPage] = useState(1);
  const { patientGuid, dateRange } = props;

  const { data, isLoading, isFetching } = useGetCombinedStatusLogs({
    patientGuid,
    page,
    dateRange,
  });

  const columns = logsColumns();

  return (
    <BaseTableNew
      rowKey={(r) => r.logType + new Date(r.createdAt).getTime()}
      dataCy="combined-status-log-table"
      columns={columns}
      items={data?.data || []}
      loading={isLoading || isFetching}
      pagination={{
        current: page,
        pageSize: COMBINED_STATUS_LOGS_PER_PAGE,
        total: data?.count || 0,
        position: ['bottomCenter'],
      }}
      onChangePage={setPage}
      bordered
    />
  );
};

export default RpmCcmStatusLog;
